<template>
  <div class="customFormItem">
      <span class="label">{{ $t('survey.question') }}</span>
      <div class="formItemContent">
        <el-card class="box-card questionsContainer" v-if="questions && questions.length">
          <ul class="questionBox">
            <li v-for="(question, i) in questions" :key="i">
              <el-row type="flex" :gutter="20">
                <el-col :span="1">
                  <span class="questionIndex">{{ question.computedQuestionIndex }}. </span>
                </el-col>
                <el-col :span="21" v-if="!question.isGroup">
                  <span class="name">{{ question.questionName }} ({{computeType(question.questionType)}})</span>
                  <div class="setting">
                    <div>
                      <p
                        v-for="(dep, i) in question.deps"
                        :key="i"
                        v-if="(dep.questionType === 1 || dep.questionType === 2)"
                      >
                        {{ $t('survey.depend') }}
                        <b>{{ $t('survey.di') }} {{ dep.computedQuestionIndex }} {{ $t('survey.ti') }} &nbsp;
                          <span v-for="(depItemId, j) in question.depResult[i]" :key="j">{{ $t('survey.option') }}{{ computeOptionIndex(dep.questionIndex, depItemId) }} &nbsp;</span>
                        </b>
                      </p>
                      <p
                        v-for="(dep, i) in question.deps"
                        :key="i"
                        v-if="dep.questionType === 3"
                      >
                        {{ $t('survey.depend') }}
                        <b>{{ $t('survey.di') }} {{ dep.computedQuestionIndex }} {{ $t('survey.ti') }} &nbsp;
                          <span v-for="(scope, k) in question.depResult[i]" :key="k" v-if="scope.isDep">
                                        {{ scope.from }}-{{ scope.to }}{{ $t('survey.fen') }}
                                      </span>
                        </b>
                      </p>
                    </div>
                    <div v-if="question.questionType === 1 || question.questionType === 2">
                      <p v-for="(item, i) in question.items" :key="i" v-if="!!question.skips[i]">
                        {{ $t('survey.option') }}{{ i + 1}} {{ $t('survey.skip') }}&nbsp;
                        <b>{{ computeSkip(question.skips[i]) }}</b>
                      </p>
                    </div>
                    <div v-if="question.questionType === 3">
                      <p v-for="(scope, i) in question.scopes" :key="i" v-if="!!question.skips[i]">
                        {{ scope.from }}-{{ scope.to }}{{ $t('survey.fen') }} {{ $t('survey.skip') }}&nbsp;
                        <b>{{ computeSkip(question.skips[i]) }}</b>
                      </p>
                    </div>
                  </div>
                </el-col>
                <el-col :span="21" v-if="question.isGroup">
                  <span class="name">
                    {{ $t('survey.questionGroupName') }}:
                    <multiInput v-model="question.groupName" />
                  </span>
                  <div class="setting">
                    <div>
                      <p
                        v-for="(dep, i) in question.deps"
                        :key="i"
                        v-if="(dep.questionType === 1 || dep.questionType === 2)"
                      >
                        {{ $t('survey.depend') }}
                        <b>{{ $t('survey.di') }} {{ dep.computedQuestionIndex }} {{ $t('survey.ti') }} &nbsp;
                          <span v-for="(depItemId, j) in question.depResult[i]" :key="j">{{ $t('survey.option') }}{{ computeOptionIndex(dep.questionIndex, depItemId) }} &nbsp;</span>
                        </b>
                      </p>
                      <p
                        v-for="(dep, i) in question.deps"
                        :key="i"
                        v-if="dep.questionType === 3"
                      >
                        {{ $t('survey.depend') }}
                        <b>{{ $t('survey.di') }} {{ dep.computedQuestionIndex }} {{ $t('survey.ti') }} &nbsp;
                          <span v-for="(scope, k) in question.depResult[i]" :key="k" v-if="scope.isDep">
                                        {{ scope.from }}-{{ scope.to }}{{ $t('survey.fen') }}
                                      </span>
                        </b>
                      </p>
                    </div>
                  </div>
                  <div style="margin-top: 20px">
                    <el-radio v-model="question.groupType" :label="1" border>同选项合并</el-radio>
                    <el-radio v-model="question.groupType" :label="2" border>非同选项叠加</el-radio>
                  </div>
                  <div class="innerQuestionBox">
                    <ul class="questionBox">
                      <li v-for="(innerQuestion, j ) in question.groupQuestions" :key="j">
                        <el-row type="flex" :gutter="20">
                          <el-col :span="1">
                            <span class="questionIndex">{{ j + 1 }}) </span>
                          </el-col>
                          <el-col :span="20" >
                            <span class="name">{{ innerQuestion.questionName }} ({{computeType(innerQuestion.questionType)}})</span>

                            <div class="setting">
                              <div>
                                <p
                                  v-for="(innerDep, i) in innerQuestion.deps"
                                  :key="i"
                                  v-if="(innerDep.questionType === 1 || innerDep.questionType === 2)"
                                >
                                  {{ $t('survey.depend') }}
                                  <b>{{ $t('survey.di') }} {{ innerDep.questionIndex + 1 }} {{ $t('survey.ti') }} &nbsp;
                                    <span v-for="(depItemId, j) in innerQuestion.depResult[i]" :key="j">{{ $t('survey.option') }}{{ computeOptionIndex(innerDep.questionIndex, depItemId) }} &nbsp;</span>
                                  </b>
                                </p>
                                <p
                                  v-for="(innerDep, i) in innerQuestion.deps"
                                  :key="i"
                                  v-if="innerDep.questionType === 3"
                                >
                                  {{ $t('survey.depend') }}
                                  <b>{{ $t('survey.di') }} {{ innerDep.questionIndex + 1 }} {{ $t('survey.ti') }} &nbsp;
                                    <span v-for="(scope, k) in innerQuestion.depResult[i]" :key="k" v-if="scope.isDep">
                                        {{ scope.from }}-{{ scope.to }}{{ $t('survey.fen') }}
                                      </span>
                                  </b>
                                </p>
                              </div>
                            </div>

                          </el-col>
                          <el-col :span="3">
                            <i class="el-icon-setting" @click="onSettingInner(i, j)" style="margin-right: 6px"></i>
                            <i class="el-icon-delete" @click="onDeleteInner(i, j)"></i>
                          </el-col>
                        </el-row>
                      </li>
                    </ul>
                  </div>

                  <el-button type="text" icon="el-icon-circle-plus-outline" size="medium" @click="addInnerQuestion(i)">{{ $t('survey.addQuestion') }}</el-button>
                </el-col>
                <el-col :span="2">
                  <i class="el-icon-setting" v-if="!question.isGroup" @click="onSetting(i)" style="margin-right: 6px"></i>
                  <i class="el-icon-delete" @click="onDelete(i)"></i>
                </el-col>
              </el-row>
            </li>
          </ul>
        </el-card>
        <div class="input-box">
          <el-button type="text" icon="el-icon-circle-plus-outline" size="medium" @click="addQuestion">{{ $t('survey.addQuestion') }}</el-button>
          <!--todo: 题目组 题目组功能下一期再做,到时候打开这个注释,接口再重新调-->
          <el-button type="text" icon="el-icon-circle-plus-outline" size="medium" @click="addQuestionGroup">添加题目组</el-button>
        </div>
      </div>
      <el-dialog
        :title="$t('survey.chooseQuestion')"
        :visible.sync="questionsDialog"
        width="50%"
        center>
        <div style="margin: 10px 0 20px">
          <el-input
            :placeholder="$t('filters.enterQuestionName')"
            v-model="searchKey">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <el-button slot="append" @click="getQuestions">{{ $t('filters.search') }}</el-button>
          </el-input>
        </div>
        <div class="checkboxList questionList">
          <el-checkbox-group v-model="checkList">
            <el-checkbox v-for="(question, i) in questionList" :key="i" :label="question.id">{{ question.name }}</el-checkbox>
          </el-checkbox-group>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="chooseQuestions">{{ $t('confirm') }}</el-button>
          <el-button @click="questionsDialog = false">{{ $t('cancel') }}</el-button>
        </span>
      </el-dialog>
      <el-dialog
        :title="$t('survey.editLogic')"
        :visible.sync="editDialog"
        width="70%"
        center>
        <div style="margin: 10px 0 20px">
          <div>{{ currentEdit.showIndex }} &nbsp; {{ currentEdit.questionName || (currentEdit.groupName && currentEdit.groupName.zh) }} ({{ computeType(currentEdit.questionType) }})</div>
          <ul style="margin-top: 20px" v-if="!currentEdit.isGroup && (currentEdit.questionType === 1 || currentEdit.questionType === 2)">
            <li v-for="(opt, i) in currentEdit.items" :key="i" style="margin-top: 10px">
              <el-row type="flex" justify="center" align="middle">
                <el-col :span="14">
                  <div class="optionBox">{{ i + 1 }}. {{ opt.content }}</div>
                </el-col>
                <el-col :span="2">{{ $t('survey.skip') }}</el-col>
                <el-col :span="8">
                  <div>
                    <el-select v-model="currentEdit.skips[i]" :placeholder="$t('survey.chooseSkip')" style="width: 100%">
                      <el-option
                        v-for="item in skipOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                </el-col>
              </el-row>
            </li>
          </ul>
          <ul style="margin-top: 20px" v-if="currentEdit.questionType === 3">
            <li v-for="(scope, i) in currentEdit.scopes" :key="i" style="margin-top: 10px">
              <el-row type="flex" justify="center" align="middle">
                <el-col :span="11">
                  <div class="scopeBox">
                    {{ i === 0 ? 0 : ''}}
                    <el-input v-if="i !== 0" class="scopeInput" v-model="currentEdit.scopes[i].from"></el-input>
                    &nbsp;&lt; {{ $t('survey.curScore') }} &le;&nbsp;
                    {{ i === currentEdit.scopes.length - 1 ? currentEdit.maxScore : '' }}
                    <el-input v-if="i !== currentEdit.scopes.length - 1" class="scopeInput" v-model="currentEdit.scopes[i].to"></el-input>
                  </div>
                </el-col>
                <el-col :span="2">{{ $t('survey.skip') }}</el-col>
                <el-col :span="11">
                  <div>
                    <el-select v-model="currentEdit.skips[i]" :placeholder="$t('survey.chooseSkip')" style="width: 100%">
                      <el-option
                        v-for="item in skipOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                </el-col>
              </el-row>
            </li>
          </ul>
          <div class="buttonContainer">
            <el-button
              type="text"
              v-if="currentEdit.questionType === 3"
              icon="el-icon-circle-plus-outline"
              size="medium"
              @click="addScope"
            >
              {{ $t('survey.addScore') }}
            </el-button>
          </div>
          <div class="depContainer" v-if="currentEdit.index !== 1">
            <el-row :gutter="20" type="flex" align="">
              <el-col :span="4">
                <div class="align-item">
                  {{ $t('survey.questionDep') }}
                </div>
              </el-col>
              <el-col :span="19">
                <ul class="depList">
                  <li v-for="(question, i) in currentEdit.deps" :key="i">
                    <el-row :gutter="10" type="flex" align="baseline">
                      <el-col :span="23">
                        <div v-if="question.questionType === 1 || question.questionType === 2">
                          <div class="optionBox">
                            {{ question.computedQuestionIndex }}. {{ question.questionName }}
                          </div>
                          <div class="optContainer checkboxList">
                            <el-checkbox-group v-model="currentDeps[i]">
                              <el-checkbox v-for="(item, j) in question.items" :key="j" :label="item.id">{{ j + 1 }}. {{ item.content }}</el-checkbox>
                            </el-checkbox-group>
                          </div>
                          <div>{{ $t('survey.appear') }}</div>
                        </div>
                        <div v-if="question.questionType === 3">
                          <div class="optionBox">
                            {{ question.computedQuestionIndex }}. {{ question.questionName }}
                          </div>
                          <div class="optContainer checkboxList">
                            <div v-for="(scope, k) in currentDeps[i]" :key="k">
                              <el-checkbox v-model="currentDeps[i][k].isDep">
                                <em v-if="k === 0">0</em>
                                <el-input class="scopeInput" v-model="currentDeps[i][k].from" v-if="k !== 0"></el-input>
                                &nbsp;&lt; {{ $t('survey.curScore') }} &le;&nbsp;
                                <em v-if="k === currentDeps[i].length - 1">{{ question.maxScore }}</em>
                                <el-input class="scopeInput" v-model="currentDeps[i][k].to" v-if="k !== currentDeps[i].length - 1"></el-input>
                              </el-checkbox>
                            </div>
                            <el-button
                              type="text"
                              icon="el-icon-circle-plus-outline"
                              size="medium"
                              @click="addDepScope(i)"
                            >
                              {{ $t('survey.addScore') }}
                            </el-button>
                          </div>
                          <div>{{ $t('survey.appear') }}</div>
                        </div>
                      </el-col>
                      <el-col :span="1">
                        <div class="align-item">
                          <i class="el-icon-delete" @click="onDeleteDep(i)"></i>
                        </div>
                      </el-col>
                    </el-row>
                  </li>
                </ul>
                <el-button
                  type="text"
                  icon="el-icon-circle-plus-outline"
                  size="medium"
                  @click="addDepQuestion"
                >
                  {{ $t('survey.addQuestion') }}
                </el-button>
              </el-col>
            </el-row>
            <el-row :gutter="20" type="flex" align="middle" v-if="currentEdit.deps && currentEdit.deps.length >= 2">
              <el-col :span="4">
                <div class="align-item">
                  {{ $t('survey.multiDep') }}:
                </div>
              </el-col>
              <el-col :span="19">
                <el-radio-group v-model="currentEdit.depLogic">
                  <el-radio :label="1">{{ $t('survey.depType1') }}</el-radio>
                  <el-radio :label="2">{{ $t('survey.depType2') }}</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="confirmSetting">{{ $t('submit') }}</el-button>
          <el-button @click="editDialog = false">{{ $t('close') }}</el-button>
        </span>
        <el-dialog
          width="50%"
          :title="$t('survey.chooseDep')"
          center
          :visible.sync="innerQuestionDialog"
          append-to-body
        >
          <div class="checkboxList questionList">
            <el-checkbox-group v-model="innerCheckList">
              <el-checkbox v-for="(question, i) in innerQuestionList" :key="i" :label="question.questionId">{{ question.computedQuestionIndex }}. {{ question.questionName }}</el-checkbox>
            </el-checkbox-group>
          </div>
          <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="chooseDepQuestions">{{ $t('confirm') }}</el-button>
          <el-button @click="innerQuestionDialog = false">{{ $t('cancel') }}</el-button>
        </span>
        </el-dialog>
      </el-dialog>
    </div>
</template>

<script>
import _ from 'lodash'
import multiInput from './multiInput'
import { multiInputFormat } from '@/utils/global'

export default {
  name: 'editQuestions',
  props: {
    value: Array
  },
  components: {
    multiInput: multiInput
  },
  data: function () {
    return {
      questionsDialog: false,
      editDialog: false,
      initQuestions: [],
      questions: this.value || [], // 问卷包含的题目
      questionList: [], // 供筛选的问题列表
      innerQuestionList: [], // 供筛选的依赖问题列表
      innerQuestionDialog: false,
      checkList: [], // 选中的问题
      innerCheckList: [], // 选中的依赖问题
      searchKey: '', // 搜索问题关键字
      currentEdit: {
        questionId: '',
        questionName: '',
        questionIndex: '',
        items: [],
        scopes: []
      }, // 当前编辑逻辑的题目
      currentDeps: [], // 当前编辑题目的依赖
      skipOptions: [],
      editGroupIndex: null, // 正在给第几题题目组添加题目
      editType: 0 // 0表示编辑普通题目, 1表示编辑题目组里的题目
    }
  },
  mounted () {
    console.log('this.questions', this.questions)
  },
  computed: {
    defaultSkip () {
      return [
        {
          name: this.$t('survey.skipType1'),
          id: '' // 正常跳转
        },
        {
          name: this.$t('survey.skipType2'),
          id: 'type-2' // 跳到结尾
        },
        {
          name: this.$t('survey.skipType3'),
          id: 'type-3' // 视为无效问卷
        }
      ]
    }
  },
  methods: {
    change: function () {
      this.$emit('input', this.questions)
    },
    debugQuestions: function () {
      console.log('this.questions', this.questions)
    },
    getQuestions: async function () {
      this.checkList = []
      let res = await window.instance.post(window.surveyUrl + '/question/list', { name: this.searchKey, size: 1000 })
      res = res.data
      if (res.code === 200) {
        this.questionList = res.data.list
      } else {
        // todo
      }
    },

    // 设置依赖和跳转
    onSetting: function (index) {
      this.editType = 0 // 编辑外层题目
      this.editDialog = true
      this.innerCheckList = []
      const selectedQuestion = this.questions[index]
      console.log('selectedQuestion', selectedQuestion)
      this.currentEdit = _.cloneDeep(selectedQuestion)
      console.log('this.currentEdit', this.currentEdit)
      this.currentEdit.index = index + 1
      this.currentEdit.showIndex = index + 1 + '.'
      this.currentEdit.isGroup = false
      // todo(问题): 目前不支持跳转到题目组,因为题目组没有id
      let skipQuestions = _.filter(_.takeRight(this.questions, this.questions.length - index - 1), function (o) { return !o.isGroup })
      skipQuestions = _.map(skipQuestions, (question, i) => ({ name: 1 + question.questionIndex + '. ' + question.questionName, id: question.questionId }))
      this.skipOptions = _.concat(this.defaultSkip, skipQuestions)
      this.currentDeps = this.currentEdit.depResult ? _.cloneDeep(this.currentEdit.depResult) : []
    },

    // 设置题目组内的题目的依赖
    onSettingInner: function (index, indexInner) {
      this.editType = 1 // 编辑题目组内层题目
      this.editDialog = true
      this.innerCheckList = []
      const selectedQuestion = this.questions[index].groupQuestions[indexInner]
      this.currentEdit = _.cloneDeep(selectedQuestion)
      this.currentEdit.index = index + 1
      this.currentEdit.innerIndex = indexInner + 1
      this.currentEdit.showIndex = index + 1 + '.' + (indexInner + 1) + ')'
      this.currentEdit.isGroup = true
      console.log('this.currentEdit', this.currentEdit)
      this.currentDeps = this.currentEdit.depResult ? _.cloneDeep(this.currentEdit.depResult) : []
    },

    // 从questions列表里删除指定的项
    onDelete: function (index) {
      const tipContent = this.$t('question.deleteQuestion') + '?'
      const tip = this.$t('tip')
      this.$confirm(tipContent, tip, {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      })
        .then(async () => {
          this.questions.splice(index, 1)
          this.resetQuestionIndex()
          this.change()
        })
        .catch(_ => {})
    },

    // 从题目组的题目列表里删除指定的项
    onDeleteInner: function (index, indexInner) {
      const tipContent = this.$t('question.deleteQuestion') + '?'
      const tip = this.$t('tip')
      this.$confirm(tipContent, tip, {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      })
        .then(async () => {
          this.questions[index].groupQuestions.splice(indexInner, 1)
          this.resetGroupQuestionIndex(index)
          this.change()
        })
        .catch(_ => {})
    },

    // 从当前编辑题目的依赖的题目里删除指定的项
    onDeleteDep: function (index) {
      const tipContent = this.$t('survey.deleteDep') + '?'
      const tip = this.$t('tip')
      this.$confirm(tipContent, tip, {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      })
        .then(async () => {
          this.currentDeps.splice(index, 1)
          this.currentEdit.deps.splice(index, 1)
        })
        .catch(_ => {})
    },

    // 选择问卷要添加的题目
    addQuestion: function () {
      this.questionsDialog = true
    },

    // 选择题目要依赖的题目
    addDepQuestion: function () {
      this.innerQuestionDialog = true
      let curIndex = this.currentEdit.index
      const copyQuestions = _.cloneDeep(this.questions)
      // 依赖的题目也可以是题目组里的题目,需要把所有当前题目之前的题目及题目组里的题目提取出来
      const innerQuestionList = []
      const depQuestions = _.dropRight(copyQuestions, this.questions.length - curIndex + 1)
      _.each(depQuestions, (question) => {
        if (!question.isGroup) {
          innerQuestionList.push(question)
        } else {
          _.each(question.groupQuestions, (gQuestion) => {
            innerQuestionList.push(gQuestion)
          })
        }
      })
      this.innerQuestionList = innerQuestionList
    },

    // 添加跳转的分段
    addScope: function () {
      let currentScopes = this.currentEdit.scopes
      currentScopes.splice(currentScopes.length - 1, 0, { from: '', to: '' })
      this.currentEdit.scopes = currentScopes
    },

    // 添加依赖的分段
    addDepScope: function (index) {
      let currentDepScopes = _.cloneDeep(this.currentDeps[index])
      let newDepScope = { from: '', to: '', isDep: false }
      currentDepScopes.splice(currentDepScopes.length - 1, 0, newDepScope)
      this.currentDeps[index] = currentDepScopes
      const newCurrentDeps = _.cloneDeep(this.currentDeps)
      this.currentDeps = newCurrentDeps
    },

    // 确认跳转依赖逻辑
    confirmSetting: function () {
      this.currentEdit.depResult = _.cloneDeep(this.currentDeps)
      this.editDialog = false
      // 区分是外层还是内层的question
      if (!this.editType) {
        this.questions[this.currentEdit.index - 1] = _.cloneDeep(this.currentEdit)
      } else {
        this.questions[this.currentEdit.index - 1].groupQuestions[this.currentEdit.innerIndex - 1] = _.cloneDeep(this.currentEdit)
      }
      this.change()
      this.debugQuestions()
    },

    // 从题目列表里选择题目
    chooseQuestions: function () {
      this.questionsDialog = false
      console.log('this.checkList', this.checkList)
      if (_.isNil(this.editGroupIndex)) {
        // 添加到题目
        this.chooseOutQuestions()
      } else {
        // 添加到题目组
        this.chooseGroupQuestions()
      }
    },

    // 从题目列表里选择题目(添加到外层的题目)
    chooseOutQuestions: function () {
      _.each(this.checkList, (questionId, i) => {
        const existedQuestion = _.find(this.questions, (question) => {
          return question.questionId === questionId
        })
        if (!existedQuestion) {
          const matchedQuestion = _.find(this.questionList, (question) => {
            return question.id === questionId
          })
          const newQuestion = this.convertQuestion(matchedQuestion)
          this.questions.push(newQuestion)
          this.change()
        }
      })
      this.checkList = []
      this.resetQuestionIndex()
      this.debugQuestions()
    },

    // 从题目列表里选择题目(添加到题目组)
    chooseGroupQuestions: function () {
      const groupQuestions = this.questions[this.editGroupIndex].groupQuestions
      _.each(this.checkList, (questionId, i) => {
        const existedQuestion = _.find(groupQuestions, (question) => {
          return question.questionId === questionId
        })
        if (!existedQuestion) {
          const matchedQuestion = _.find(this.questionList, (question) => {
            return question.id === questionId
          })
          const newQuestion = this.convertGroupQuestion(matchedQuestion)
          this.questions[this.editGroupIndex].groupQuestions.push(newQuestion)
          this.change()
        }
      })
      this.checkList = []
      this.resetGroupQuestionIndex(this.editGroupIndex)
      this.editGroupIndex = null
      this.debugQuestions()
    },

    // 从题目列表里选择依赖的题目
    chooseDepQuestions: function () {
      this.innerQuestionDialog = false
      _.each(this.innerCheckList, (questionId) => {
        const existedQuestion = _.find(this.currentEdit.deps, (question) => {
          return question.questionId === questionId
        })
        if (!existedQuestion) {
          const matchedQuestion = _.find(this.innerQuestionList, (question) => {
            return question.questionId === questionId
          })
          if (matchedQuestion.questionType !== 4) {
            this.currentEdit.deps.push(matchedQuestion)
          }
          if (matchedQuestion.questionType === 1 || matchedQuestion.questionType === 2) {
            this.currentDeps.push([])
          } else if (matchedQuestion.questionType === 3) {
            this.currentDeps.push([{ from: 0, to: '', isDep: false }, { from: '', to: matchedQuestion.maxScore, isDep: false }])
          }
        }
      })
      console.log('this.currentEdit.deps', this.currentEdit.deps)
    },

    // 把原始的question转换成需要的question格式
    convertQuestion: function (question) {
      const result = {
        questionId: question.id,
        questionName: question.name,
        questionType: question.type,
        items: this.convertItems(question.items),
        skips: (question.type === 1 || question.type === 2) ? new Array(question.items.length) : [],
        deps: [],
        depLogic: 1
      }
      if (question.type === 3) {
        result.skips = new Array(2)
        result.maxScore = question.maxScore
        result.scopes = [
          {
            from: 0,
            to: null
          },
          {
            from: null,
            to: question.maxScore
          }
        ]
      }
      return result
    },

    // 把原始的question转换成需要的question格式(题目组里的question)
    convertGroupQuestion: function (question) {
      const result = {
        questionId: question.id,
        questionName: question.name,
        questionType: question.type,
        items: this.convertItems(question.items),
        deps: [],
        depLogic: 1,
        isGroup: true // 是题目组里的题目
      }
      return result
    },

    // 把原来的questions转换成提交需要的question格式
    convertQuestionToSubmit: function (question, index) {
      let result = {}
      result.depend = question.depLogic || 1 // 多题依赖逻辑 1.且 2.或
      result.questionId = question.questionId // 问题id
      result.num = _.toNumber(index) + 1 // 序号
      if (question.deps && question.deps.length) {
        console.log('<=======question.deps======>', question.deps)
        let depends = []
        _.each(question.deps, (dep, j) => {
          const corsDepResult = question.depResult[j]
          if (dep.questionType === 3) {
            const scoreAreas = _.map(corsDepResult, (score) => {
              return {
                startScore: _.toNumber(score.from),
                endScore: _.toNumber(score.to),
                isEnable: score.isDep
              }
            })
            depends.push({
              questionId: dep.questionId,
              scoreAreas: scoreAreas
            })
          } else if (dep.questionType === 1 || dep.questionType === 2) {
            const itemIds = _.cloneDeep(corsDepResult)
            depends.push({
              questionId: dep.questionId,
              scoreAreas: _.map(itemIds, (itemId) => ({itemId: itemId}))
            })
          }
          console.log('<=================depends===================>', depends)
        })
        result.depends = depends
      }
      console.log('<=========question.skips========>', question.skips)
      if (question.questionType === 1 || question.questionType === 2) {
        if (question.skips && question.skips.length) {
          let skips = []
          _.each(question.skips, (skip, k) => {
            const itemId = question.items[k].id
            const type = this.computeSkipTypeNumber(skip)
            const skipItem = {
              type,
              itemId
            }
            if (type === 4) {
              skipItem.questionId = skip
            }
            skips.push(skipItem)
          })
          result.skips = skips
        }
      } else if (question.questionType === 3) {
        console.log('question.skips', question.skips)
        if (question.skips && question.skips.length) {
          let skips = []
          _.each(question.skips, (skip, k) => {
            const startScore = !_.isNil(question.scopes[k].from) ? _.toNumber(question.scopes[k].from) : null
            const endScore = !_.isNil(question.scopes[k].to) ? _.toNumber(question.scopes[k].to) : null
            const type = this.computeSkipTypeNumber(skip)
            const skipItem = {
              type,
              startScore,
              endScore
            }
            if (type === 4) {
              skipItem.questionId = skip
            }
            skips.push(skipItem)
          })
          result.skips = skips
        }
      }
      console.log('<========result.skips========>', result.skips)

      return result
    },

    // 把原来的questions转换成提交需要的question格式
    convertOutQuestionToSubmit: function (question, index) {
      if (!question.isGroup) {
        return _.assignIn(this.convertQuestionToSubmit(question, index), {isGroup: false, groupQuestionNum: 0})
      }
      // 如果是题目组的话
      else {
        let result = {}
        result.isGroup = true
        result.num = _.toNumber(index) + 1 // 序号
        result.groupQuestionNum = 0
        result.groupType = question.groupType // 1选项合并 2题目堆叠
        result.groupTitle = question.groupName
        result.questionId = 0
        result.groupQuestions = _.map(question.groupQuestions, (innerQuestion, j) => {
          return _.assignIn(this.convertQuestionToSubmit(innerQuestion, j), {groupQuestionNum: j + 1, num: _.toNumber(index) + 1})
        })
        return result
      }
    },

    // 收到的数据里原始的items的顺序和它的num序号不匹配,需要重新排序
    convertItems: function (items) {
      return _.orderBy(items, ['num'])
    },

    // 计算指定的type值对应的题目类型
    computeType: function (type) {
      let result
      switch (type) {
        case 1:
          result = this.$t('question.type1')
          break
        case 2:
          result = this.$t('question.type2')
          break
        case 3:
          result = this.$t('question.type3')
          break
        case 4:
          result = this.$t('question.type4')
          break
        case 5:
          result = this.$t('question.type5')
          break
        default:
          result = ''
      }
      return result
    },

    // 计算指定的跳转值对应跳转到第几题(或者结尾,无效)
    computeSkip: function (skip) {
      if (!skip) {
        return ''
      } else if (skip === 'type-2') {
        return this.$t('survey.surveyEnd')
      } else if (skip === 'type-3') {
        return this.$t('survey.invalid')
      } else {
        let skipNum = ''
        _.each(this.questions, (question, i) => {
          if (question.questionId === skip) {
            skipNum = i + 1
          }
        })
        return this.$t('survey.di') + skipNum + this.$t('survey.ti')
      }
    },

    // 计算指定的跳转值对应提交时候的type是几
    // 1. 按顺序跳至下一题
    // 2. 跳至问卷结尾
    // 3. 无效问卷
    // 4. 指定题目
    computeSkipTypeNumber: function (skip) {
      if (_.isNumber(skip)) {
        return 4
      } else if (skip === 'type-2') {
        return 2
      } else if (skip === 'type-3') {
        return 3
      } else {
        return 1
      }
    },

    // 计算指定的itemId,在指定的question的items里的索引值
    computeOptionIndex: function (questionIndex, depItemId) {
      if (_.isNumber(questionIndex)) {
        const selQuestion = this.questions[questionIndex]
        const selItems = selQuestion.items
        return _.find(selItems, (item) => {
          return item.id === depItemId
        }).num
      } else {
        const [i, j] = questionIndex.split('_')
        const selQuestion = this.questions[i].groupQuestions[j]
        const selItems = selQuestion.items
        return _.find(selItems, (item) => {
          return item.id === depItemId
        }).num
      }
    },

    // 重置问题列表的索引
    resetQuestionIndex: function () {
      _.each(this.questions, (question, i) => {
        question.questionIndex = i
        question.computedQuestionIndex = i + 1
      })
      this.change()
    },

    // 重置题目组内问题列表的索引
    resetGroupQuestionIndex: function (index) {
      _.each(this.questions[index].groupQuestions, (question, i) => {
        // todo: 题目组里的题目需要两个索引,一个外索引一个内索引
        question.questionIndex = index + '_' + i
        question.computedQuestionIndex = (index + 1) + '_' + (i + 1)
        // question.innerQuestionIndex =
      })
      this.change()
    },

    // 添加题目组
    addQuestionGroup: function () {
      const newQuestionGroup = {
        isGroup: true, // 是否是题目组
        questionType: 5, // 指定类型是5的是题目组
        groupQuestions: [], // 题目组里包含的题目
        groupName: _.clone(multiInputFormat), // 题目组名称
        groupType: 1, // 默认同选项合并
        deps: [], // 依赖
        depLogic: 1 // 依赖方式
      }
      this.questions.push(newQuestionGroup)
      this.resetQuestionIndex()
    },

    // 题目组内添加题目
    addInnerQuestion: function (index) {
      this.questionsDialog = true
      this.editGroupIndex = index
    }
  },

  watch: {
    value: function (val, oldVal) {
      this.questions = val
    }
  }
}
</script>

<style scoped lang="scss">
  .questionList{
    height: 360px;
    overflow: auto;
  }
  .questionsContainer{
    .innerQuestionBox{
      margin: 20px 0;
    }
    .questionBox{
      &:nth-last-of-type(){
        border-bottom: 0;
      }
      li{
        font-size: 14px;
        color: #606266;
        line-height: 40px;
        border-bottom: 1px solid #efefef;
        margin-bottom: 20px;
        padding-bottom: 20px;
        &:last-child{
          border-bottom: 0;
          margin-bottom: 0;
          padding-bottom: 0;
        }
        i{
          color: #ff6801;
          cursor: pointer;
          font-size: 16px;
        }
        .setting{
          color: #aaa;
          p{
            padding: 0;
            margin: 4px 0;
            line-height: 24px;
            b{
              font-weight: 300;
              color: #01a58f;
            }
          }
        }
      }
    }
  }
  .optionBox{
    border: 1px solid rgb(220, 223, 230);
    height: 38px;
    line-height: 38px;
    margin-right: 30px;
    border-radius: 5px;
    text-indent: 10px;
  }
  .scopeBox{
    margin-right: 30px;
    margin-left: 16px;
  }
  .scopeInput{
    width: 50px;
  }
  .buttonContainer{
    margin: 8px 0 0 16px;
  }
  .depContainer{
    border-top: 1px solid #eee;
    margin-top: 40px;
    padding-top: 20px;
  }
  .align-item{
    line-height: 36px;
  }
  .depList{
    li{
      margin-bottom: 24px;
      i{
        color: #ff6801;
        cursor: pointer;
        font-size: 16px;
      }
    }
  }
  .checkboxList{
    .el-checkbox{
      display: block;
      margin: 14px 0;
      font-weight: 300;
    }
    em{
      font-style: normal;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/editQuestions.vue